module.exports = __webpack_public_path__ + "static/media/event-room-icon.1c10762c.svg";